<template>
    <div class="view-material-paper">
        <div class="title">
            {{ papername }}
        </div>
        <div class="content">
            <div class="content-container">
                <el-tabs type="border-card">
                  <el-tab-pane v-for="(item,index) in material" :key="index">
                    <span slot="label">{{ item.index }}</span>
                    <div class="materail-content" v-html="item.content">
                    </div>
                  </el-tab-pane>
            </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                material:"",
                papername:'',
            };
        },
        methods:{
            getinfo:function(){
                this.$api.GETCORRECTDATA({
                    question_id: this.$route.params.question_id
                    // user_record_id: 20206 || this.$route.params.record_id
                }).then((res) => {
                    if(res.retcode==0){
                        // this.papername = res.data.paper_name;
                        this.material = res.data.material;
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
        },
        created () {
            this.papername = window.localStorage.getItem('paper_name') + ' - ' + this.$route.params.question_num;
            this.getinfo()
        }
    }
</script>
<style lang="less" scoped>
.view-material-paper {
  .title {
    padding: 10px;
    font-weight: bolder;
  }
  .content{
      padding-bottom: 0;
      line-height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view-material/index.vue